import { h } from './index-d4808923.js';
import { c as classesToString } from './utils-17533423.js';

const BadgeBase = ({ iconName, size, textColor, class: className, title, onClick, clickable = false }, children) => {
    const classes = [`badge`, `badge--${size}`];
    const overlayClasses = ['badge--overlay', clickable ? 'badge--clickable' : ''];
    const renderLeadingIcon = () => {
        return (iconName && h("gravity-icon", { color: textColor, name: iconName, size: size === 'small' ? 'tiny' : 'xxx-small' }));
    };
    return (h("span", { class: classesToString([...classes, className !== null && className !== void 0 ? className : '']), onClick: onClick },
        h("span", { class: classesToString(overlayClasses) },
            h("slot", { name: "icon" }, renderLeadingIcon()),
            h("gravity-text", { clamp: 1, color: textColor, class: "badge__label", size: size === 'small' ? 'xx-small' : 'x-small', weight: "medium", title: title }, children))));
};

export { BadgeBase as B };

//# sourceMappingURL=badge-base-439be9eb.js.map